class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    if (new URLSearchParams(window.location.search).get('mp_cart_popup_preview') === '1') {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.openPreview.bind(this), { once: true });
      } else {
        this.openPreview();
      }
    }
  }

  open() {
    this.notification.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.renderShippingProgress();
    this.bumpCartCount();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    // Only the overlay dismisses the notification. Closing on any outside
    // click meant a click meant for something else on top of it — dismissing
    // the Klaviyo signup popup, for instance — took this away as well.
    if (evt.target.classList.contains('cart-notification__overlay')) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  openPreview() {
    const product = this.querySelector('#cart-notification-product');
    const message = this.querySelector('#cart-notification-shipping-message');
    const bar = this.querySelector('#cart-notification-shipping-bar');
    if (!product) return;

    product.innerHTML = `
      <div class="cart-item">
        <div class="cart-notification-product__image global-media-settings">
          <img
            src="//giftmasy.com/cdn/shop/files/GIFTMASY-logo.png?width=140"
            alt="Giftmasy"
            width="70"
            height="70"
            loading="lazy"
          >
        </div>
        <div>
          <h3 class="cart-notification-product__name h4">Colorful Cat Face Quilted Tote</h3>
          <dl>
            <div class="product-option">
              <dt>Style:</dt>
              <dd>Preview item · Qty 1</dd>
            </div>
          </dl>
        </div>
      </div>
    `;

    if (message) message.innerHTML = `You're <strong>$65.05</strong> away from <strong>free US shipping</strong>`;
    if (bar) bar.style.width = '90%';
    this.open();
  }

  renderShippingProgress() {
    const message = this.querySelector('#cart-notification-shipping-message');
    const bar = this.querySelector('#cart-notification-shipping-bar');
    if (!message || !bar) return;

    fetch(`${routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => {
        const threshold = 10000;
        const total = Number(cart.total_price) || 0;
        const remaining = Math.max(0, threshold - total);
        const progress = Math.min(100, (total / threshold) * 100);
        const formattedRemaining = this.formatMoney(remaining);

        bar.style.width = `${progress}%`;
        message.innerHTML =
          remaining > 0
            ? `You're <strong>${formattedRemaining}</strong> away from <strong>free US shipping</strong>`
            : `<strong>You've unlocked free US shipping</strong>`;
      })
      .catch(() => {
        bar.style.width = '0%';
        message.textContent = "You're almost at free US shipping";
      });
  }

  bumpCartCount() {
    const bubble = document.querySelector('.cart-count-bubble');
    if (!bubble) return;

    bubble.classList.remove('cart-bump');
    bubble.offsetWidth;
    bubble.classList.add('cart-bump');
  }

  formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents);

    const amount = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
      }).format(amount);
    } catch (error) {
      return `$${amount.toFixed(2)}`;
    }
  }
}

customElements.define('cart-notification', CartNotification);
